import { render, staticRenderFns } from "./RentalVenueBody.vue?vue&type=template&id=4d0d06b8&scoped=true&"
import script from "./RentalVenueBody.vue?vue&type=script&lang=js&"
export * from "./RentalVenueBody.vue?vue&type=script&lang=js&"
import style0 from "./RentalVenueBody.vue?vue&type=style&index=0&id=4d0d06b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d06b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0d06b8')) {
      api.createRecord('4d0d06b8', component.options)
    } else {
      api.reload('4d0d06b8', component.options)
    }
    module.hot.accept("./RentalVenueBody.vue?vue&type=template&id=4d0d06b8&scoped=true&", function () {
      api.rerender('4d0d06b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/RentalVenue/RentalVenueBody.vue"
export default component.exports